<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form" class="flex flex-col justify-between">
    <base-form-header
      (onClose)="close(false)"
      [mode]="mode"
      createLabel="Ouvrir une demande"
      updateLabel="Modifier le ticket"
    ></base-form-header>

    <mat-dialog-content class="flex flex-col">
      <p class="mb-6">Veuillez préciser le type de la demande</p>
      <base-form-input
        label="Type de demande"
        controlName="requestType"
        type="select"
        [items]="requestTypeOptions"
        displayProperty="label"
      ></base-form-input>

      <ng-container *ngIf="isCompetence()">
        <p class="mb-6">Veuillez sélectionner un motif</p>
        <base-form-input
          label="Motif"
          controlName="metrikMotif"
          type="select"
          [items]="metrikMotifs"
          displayProperty="label"
        ></base-form-input>

        <p class="mb-6">Veuillez justifier votre demande</p>
        <base-form-input label="Justificatif" controlName="justification" type="text"></base-form-input>

        <competence-schedule-fields [form]="form" [minDate]="today"></competence-schedule-fields>
      </ng-container>

      <p class="mb-6">Veuillez sélectionner un établissement</p>
      <base-form-input
        label="Établissement"
        controlName="establishment"
        type="autocomplete"
        [items$]="establishments$"
        displayProperty="label"
        (autocompleteChange)="autocompleteEstablishment($event)"
      ></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [loading]="loading"
        [mode]="mode"
        saveButtonLabel="OUVRIR LA DEMANDE"
        entityLabel="TICKET-EQUIPMENT"
        [showCancelButton]="false"
        [disabled]="!form.valid"
        (onCreate)="createItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    [label]="data.defaults.technicalIdentifier"
    defaultMessage="Êtes vous sur de vouloir supprimer ce ticket ?"
    (onDelete)="deleteItem()"
    [loading]="loading"
    (onClose)="close(null)"
  ></form-modal-delete-base>
</ng-container>

<ng-container *ngIf="isArchiveMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="archiveItem()"
    title="Archiver la récéption"
    defaultMessage="Êtes-vous sûr de vouloir archiver cette récéption ?"
  ></form-modal-delete-base>
</ng-container>
